// client/src/components/messages/ReadReceipt.jsx
// Status for the current user's own messages, following the common
// messenger convention: clock = sending, ✓ = sent, ✓✓ = read, ! = not sent.
// The icon shape changes per state and every state has a text label, so
// status never relies on colour alone (WCAG 1.4.1).
import React from 'react';

const LABELS = {
  sending: 'Sending',
  sent: 'Sent',
  read: 'Read',
  failed: 'Not sent',
};

export function receiptLabel({ status, readCount, total }, isGroup) {
  if (isGroup && (status === 'sent' || status === 'read') && total > 0) {
    return status === 'read' ? 'Read by everyone' : `Read by ${readCount} of ${total}`;
  }
  return LABELS[status] || '';
}

const svgProps = {
  width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none',
  stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round',
  strokeLinejoin: 'round', 'aria-hidden': true, focusable: false,
};

export default function ReadReceipt({ receipt, isGroup }) {
  const { status } = receipt;
  const label = receiptLabel(receipt, isGroup);

  return (
    <span className={`msg-receipt msg-receipt--${status}`} role="img" aria-label={label} title={label}>
      {status === 'sending' && (
        <svg {...svgProps}><circle cx="8" cy="8" r="5.5" /><path d="M8 5v3l2 1.5" /></svg>
      )}
      {status === 'sent' && (
        <svg {...svgProps}><path d="M3.5 8.5l3 3 6-7" /></svg>
      )}
      {status === 'read' && (
        <svg {...svgProps} width={20} viewBox="0 0 20 16">
          <path d="M1.5 8.5l3 3 6-7" /><path d="M8.5 11.5l.5.5 6.5-7.5" />
        </svg>
      )}
      {status === 'failed' && (
        <svg {...svgProps}><circle cx="8" cy="8" r="6" /><path d="M8 5v3.5M8 11h.01" /></svg>
      )}
    </span>
  );
}
